(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reinsurance-popin"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
	document.addEventListener('ABTastyScenariB', () => {
		if (!window.location.pathname.includes('/products/')) return;

		const POPIN_KEY = 'reinsurance_popin_seen';
		const SESSION_KEY = `${POPIN_KEY}_${window.location.pathname}`;

		if (sessionStorage.getItem(SESSION_KEY)) return;

		function waitForDataReady(selector) {
			return new Promise((resolve) => {
				const el = document.querySelector(selector);
				if (el) return resolve(el);

				const observer = new MutationObserver(() => {
					const element = document.querySelector(selector);
					if (element) {
						observer.disconnect();
						resolve(element);
					}
				});

				const bodyObserver = new MutationObserver(() => {
					const element = document.querySelector(selector);
					if (element) {
						bodyObserver.disconnect();
						observer.observe(element, { attributes: true });
					}
				});

				bodyObserver.observe(document.body, { childList: true, subtree: true });
			});
		}

		waitForDataReady('#splide02-slide01').then(() => {
			const popin = document.querySelector('.c-reinsurance-popin');
			const targetMobile = document.querySelector('#add-to-cart');
			const targetFromTablet = document.querySelector('#splide02-slide01');
			const target = window.innerWidth > 768 ? targetFromTablet : targetMobile;

			if (!popin || !target) return;

			const phoneBtn = popin.querySelector('.c-insurance-popin__inner_cta_phone');
			const closeBtn = popin.querySelector('[data-reinsurance-popin-close]');

			let lastScrollY = window.scrollY;
			let hasScrolledCondition = false;
			let hasTimeCondition = false;
			let isVisible = false;

			function showPopin() {
				popin.classList.remove('hidden');
				isVisible = true;
				document.documentElement.style.setProperty('--reinsurance-popin', `${popin.offsetHeight + 10}px`);

				if (!window.location.href.includes('dev')) {
					ABTastyClickTracking('cc_impression');
					if (closeBtn) {
						closeBtn.addEventListener('click', () => {
							ABTastyClickTracking('cc_close');
						});
					}
					phoneBtn.addEventListener('click', () => {
						ABTastyClickTracking('cc_tel_click');
					})
				}
			}

			setTimeout(() => {
				hasTimeCondition = true;
				if (hasScrolledCondition && !isVisible) showPopin();
			}, 10000);

			function handleScroll() {
				const currentScrollY = window.scrollY;
				const isScrollingDown = currentScrollY > lastScrollY;
				const viewportHeight = window.innerHeight;
				const rect = target.getBoundingClientRect();
				const threshold = viewportHeight / 2;

				if (isScrollingDown && rect.bottom <= threshold) {
					hasScrolledCondition = true;
					if (hasTimeCondition && !isVisible) showPopin();
				}
				lastScrollY = currentScrollY;
				if (hasScrolledCondition && !isVisible && hasTimeCondition) showPopin();
			}

			window.addEventListener('scroll', handleScroll);

			if (closeBtn) {
					closeBtn.addEventListener('click', () => {
						popin.remove();
						sessionStorage.setItem(SESSION_KEY, 'true');
						document.documentElement.style.removeProperty('--reinsurance-popin');
					});
				}
			});
		});
	});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reinsurance"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
      document.addEventListener('ABTastyScenariC', () => {
        // event for scenario C
        ABTastyClickTracking('cc_impression');
        const productExpandle = document.querySelectorAll('.c-expandable__btn');
        const regex = /^content_.*_8$/;
        const description = Array.from(productExpandle).filter(expandable => regex.test(expandable.getAttribute('aria-controls')))[0];

        // hide description
        document.addEventListener('expandable:ready', () => {
            if (description && description.getAttribute('aria-expanded') === 'true') {
                description.click();
                description.addEventListener('click', () => {
                    ABTastyClickTracking('cc_description');
                })
            }
        });

        setTimeout(() => {
            if (description && description.getAttribute('aria-expanded') === 'true') {
                description.click();
                description.addEventListener('click', () => {
                    ABTastyClickTracking('cc_description');
                })
            }
        }, 1000);

        // show reinsurance
        const el = document.querySelector('.c-reinsurance');
        el.classList.remove('hidden');

        // event on click
        el.querySelector('a').addEventListener('click', () => {
            ABTastyClickTracking('cc_tel_click');
        });
    });
    });
  } catch(e) { console.error(e); }
})();

})();
